// Import dependencies
import { initialiser } from '../../ramen-imports/utilitybelt';

class MultiRangeSlider {
  constructor(config) {
    const { el, settings } = config;

    this.container = el;
    this.settings = settings;

    this.rangeA = el.querySelector(settings.inputLeft);
    this.rangeB = el.querySelector(settings.inputRight);
    this.inverseLeft = el.querySelector(settings.inverseLeft);
    this.inverseRight = el.querySelector(settings.inverseRight);
    this.range = el.querySelector(settings.range);
    this.thumbLeft = el.querySelector(settings.thumbLeft);
    this.thumbRight = el.querySelector(settings.thumbRight);
    this.valueLeft = el.querySelector(settings.valueLeft);
    this.valueRight = el.querySelector(settings.valueRight);
    this.steps = parseInt(this.rangeA.getAttribute('step'), 10);
  }

  init = () => {
    this.bindEvents();
  };

  bindEvents = () => {
    this.rangeA.addEventListener('input', this.setLeftValue);
    this.rangeB.addEventListener('input', this.setRightValue);
  };

  setLeftValue = () => {
    this.rangeA.value = Math.min(this.rangeA.value, this.rangeB.value - this.steps);
    const ratio = 100 / (this.rangeA.max - this.rangeA.min);
    const value = Number((ratio * this.rangeA.value) - (ratio * this.rangeA.min)).toFixed(1);

    this.inverseLeft.style.width = `${value}%`;
    this.range.style.left = `${value}%`;
    this.thumbLeft.style.left = `${value}%`;

    this.valueLeft.innerHTML = `$${this.rangeA.value}`;
  };

  setRightValue = () => {
    this.rangeB.value = Math.max(this.rangeB.value, this.rangeA.value - -this.steps);
    const ratio = 100 / (this.rangeB.max - this.rangeB.min);
    const value = (ratio * this.rangeB.value) - (ratio * this.rangeB.min);

    this.inverseRight.style.width = `${100 - value}%`;
    this.range.style.right = `${100 - value}%`;
    this.thumbRight.style.left = `${value}%`;

    this.valueRight.innerHTML = `$${this.rangeB.value}`;
  };
}

export default (settings) => initialiser(settings, MultiRangeSlider);
